import { render } from "./ListItemOutraPublicacao.vue?vue&type=template&id=79677c23&scoped=true"
import script from "./ListItemOutraPublicacao.vue?vue&type=script&lang=js"
export * from "./ListItemOutraPublicacao.vue?vue&type=script&lang=js"

import "./ListItemOutraPublicacao.vue?vue&type=style&index=0&id=79677c23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79677c23"]])

export default __exports__